import React, { useEffect, useState } from "react";
// context
import { useAuth } from "../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
// form
import { validationSchema } from "./validationSchema";
import { useFormik, FormikProvider } from "formik";
// components
import GeneralData from "./GeneralData";
import Scheduler from "../Scheduler";
import ChannelSend from "./ChannelSend";
import MessageText from "./MessageText";
import MessageSimpleRcs from "./MessageSimpleRcs";
import _ModalConfirmMulti from "../../modal/_ModalConfirmMulti";
// actions
import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
// toast
import { ErrorMessage, SuccessMessage } from "../../../utils/toastify";
// random uuid
import { generateRandomUUID, errorLabels } from "../../../utils/helpers";
import { EmailForm } from "./email";
import { WhatsappForm } from "./wa";
import CreateMessageRcs from "../../../utils/classes/create-message-rcs";

const CampaignsMultiForm = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  let { token, uid_partner, uid_user } = auth.getSessionData();

  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const initialValues = {
    partner: uid_partner,
    uidUser: uid_user,
    uuid_campaign: generateRandomUUID(),
    campaignName: "",
    uiddatabase: "",
    mask: "",
    dateSend: "",
    proghour: "",
    hour: 0,
    minute: 0,
    idshortcode: "0",
    listDatabases: [],
    listMask: [],
    listShortLinks: [],
    message: "",
    template: "",
    rcsmessage: "",
    isScheduled: false,
    isSms: false,
    isRcs: false,
    isWhatsapp: false,
    isEmail: false,
    whmessage: "",
    whtemplate: "",
    whparameters: "",
    selectedTemplate: "",
    email_message: "",
    email_subject: "",
    email_template: "",
    imageUrl: "",
    height: "",
    carrousel: [],
    title_rcs_message: "",
    step: 1,
    buttonActions: [],
    buttonQuickReplies: [],
    parameters: "",
    fallback: "",
    template_fallback: "",
    thumbnail_url: "",
    cardOrientation: "",
  };
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    validateOnChange: true,
    onSubmit: async (values) => {
      setIsLoading(true);

      try {
        await _action(values);
        SuccessMessage("Campaña enviada con éxito");
        navigate("/Campaigns");
        formik.resetForm();
      } catch (error) {
        let message = error?.message || "Error al enviar la campaña";
        ErrorMessage(`${message}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  const _action = async (values) => {
    let uri = "campaigns/createCampaign";

    if (values.isScheduled) {
      uri = "campaigns/programCampaign";
    }

    const Resolver = new CreateMessageRcs(values);

    const data = await Resolver.multichannel();

    const res = await httpClient("POST", `${ApiEndpoint}${uri}`, data, token);
    if (res?.data?.error) {
      const error =
        res.data.Errorcode === "0"
          ? "No cuenta con SMS suficientes para la campaña"
          : "Ya existe una campaña con ese nombre";
      throw new Error(error);
    }

    return res;
  };

  const getListDatabase = (uid_partner) => {
    httpClient(
      "POST",
      `${ApiEndpoint}campaigns/getPartnerDatabasesActive`,
      { id: `${uid_partner}`, iduser: uid_user },
      token,
    ).then((response) => {
      formik.setFieldValue("listDatabases", response.data, false);
    });
  };

  const getShortLinks = () => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/shortLinks/${uid_partner}`,
      {},
      token,
    ).then((response) => {
      formik.setFieldValue(
        "listShortLinks",
        response.data.filter((x) => x.active),
        false,
      );
    });
  };

  const getExtraFieldsInfo = (uidDatabase) => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/fieldsdatabase/${uidDatabase}`,
      {},
      token,
    ).then((response) => {
      formik.setFieldValue("fieldsInfo", response.data, false);
    });
  };

  const getAvMask = () => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/masks/${uid_partner}`,
      {},
      token,
    ).then((response) => {
      formik.setFieldValue("listMask", response.data, false);
    });
  };

  useEffect(() => {
    getListDatabase(uid_partner);
    getShortLinks();
    getAvMask();
  }, []);

  useEffect(() => {
    if (formik.values.uiddatabase !== "") {
      getExtraFieldsInfo(formik.values.uiddatabase);
    }
  }, [formik.values.uiddatabase]);

  const onValidate = async () => {
    try {
      const isValid = await formik.validateForm();
      console.log(isValid);
      const isSelectedChannel =
        formik.values.isRcs ||
        formik.values.isSms ||
        formik.values.isWhatsapp ||
        formik.values.isEmail;
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }

      if (!isSelectedChannel) {
        throw new Error(`Selecciona al menos un canal de envio SMS o RCS`);
      }

      setVisible(true);
    } catch (error) {
      setVisible(false);
      ErrorMessage(error.message);
    }
  };

  useEffect(() => {
    if (!formik.values.isSms) {
      formik.setFieldValue("message", "");
    }

    if (!formik.values.isRcs) {
      formik.setFieldValue("rcsmessage", "");
    }

    if (!formik.values.isWhatsapp) {
      formik.setFieldValue("whmessage", "");
      formik.setFieldValue("whtemplate", "");
      formik.setFieldValue("whparameters", "");
    }

    if (!formik.values.isEmail) {
      formik.setFieldValue("email_message", "");
      formik.setFieldValue("email_template", "");
      formik.setFieldValue("email_subject", "");
    }
  }, [
    formik.values.isSms,
    formik.values.isRcs,
    formik.values.isWhatsapp,
    formik.values.isEmail,
  ]);

  useEffect(() => {
    formik.setFieldValue("buttonActions", []);
    formik.setFieldValue("buttonQuickReplies", []);
  }, [formik.values.step]);

  const components = [
    { key: "general", element: <GeneralData /> },
    { key: "channel", element: <ChannelSend /> },
    formik.values.isSms && {
      key: "sms",
      element: <MessageText />,
    },
    formik.values.isRcs && { key: "rcs", element: <MessageSimpleRcs /> },
    formik.values.isWhatsapp && {
      key: "whatsapp",
      element: <WhatsappForm />,
    },
    formik.values.isEmail && {
      key: "email",
      element: <EmailForm />,
    },
    {
      key: "scheduler",
      element: <Scheduler isLoading={isLoading} onValidate={onValidate} />,
    },
  ].filter(Boolean);
  return (
    <FormikProvider value={formik}>
      <div className="flex justify-center">
        <div className="space-y-2 w-[1000px]">
          {components.map(({ key, element }, index) =>
            React.cloneElement(element, { step: index + 1, key }),
          )}
        </div>
      </div>
      <_ModalConfirmMulti
        title="Confirmar Campaña"
        onClose={() => setVisible(false)}
        onAction={async () => await formik.submitForm()}
        description="¿Estas seguro de crear la campaña?"
        data={formik.values}
        visible={visible}
        isLoading={isLoading}
      />
    </FormikProvider>
  );
};

export default CampaignsMultiForm;
